module.exports = __webpack_public_path__ + "media/68.b7de9344.wav";